import React from 'react';
import { PORTAL_TYPES } from '../constants/portalType';
import ClinicalChatIcon from '../../assets/chatIcons/clinical-chat-icon.svg';
import FacilityChatIcon from '../../assets/chatIcons/facility-chat-icon.svg';
import OpsChatIcon from '../../assets/chatIcons/ops-chat-icon.svg';

export const getPortalIcon = (portalType?: string): React.ReactNode => {
  switch (portalType) {
    case PORTAL_TYPES.CLINICAL:
      return <ClinicalChatIcon />;
    case PORTAL_TYPES.FACILITY:
      return <FacilityChatIcon />;
    case PORTAL_TYPES.OPERATIONS:
      return <OpsChatIcon />;
    default:
      return null;
  }
};
